!function(){
  const $$=(s,c)=>Array.from((c||document).querySelectorAll(s));
  const $=(s,c)=>(c||document).querySelector(s);
  let scrollY=0;
  const lockScroll=()=>{scrollY=window.scrollY||0;document.body.style.top=`-${scrollY}px`;document.body.classList.add('vs-scroll-lock');};
  const unlockScroll=()=>{document.body.classList.remove('vs-scroll-lock');document.body.style.top='';window.scrollTo(0,scrollY);};
  const tryPlay=v=>v&&v.play&&v.play().catch(()=>{});
  const safePlay=async(v,o)=>{
    if(!v)return false;o=o||{};
    const t={};v._vsT=t;
    try{if(o.muted!==undefined)v.muted=o.muted;}catch{}
    if(o.fromStart){try{v.currentTime=0;}catch{}}
    try{if(v.preload!=='auto')v.preload='auto';}catch{}
    for(let i=0;i<3;i++){
      if(v._vsT!==t)return false;
      try{const p=v.play();if(p&&p.then)await p;return true;}
      catch(e){
        if(v._vsT!==t)return false;
        const n=e&&e.name;
        if(n==='AbortError')await new Promise(r=>setTimeout(r,80));
        else if(n==='NotAllowedError'&&!v.muted){try{v.muted=true;}catch{}}
        else return false;
      }
    }
    return false;
  };
  const safePause=v=>{if(!v)return;v._vsT=null;try{v.pause();}catch{}};
  let biblioHls=null;
  const chargerBiblioHls=()=>{
    if(window.Hls)return Promise.resolve(window.Hls);
    if(biblioHls)return biblioHls;
    const racine=document.querySelector('.vs-root[data-hls-lib]');
    const url=racine&&racine.getAttribute('data-hls-lib');
    if(!url)return Promise.resolve(null);
    biblioHls=new Promise(res=>{
      const sc=document.createElement('script');
      sc.src=url;sc.async=true;
      sc.onload=()=>res(window.Hls||null);
      sc.onerror=()=>res(null);
      document.head.appendChild(sc);
    });
    return biblioHls;
  };

  const brancherHls=(v)=>{
    const flux=v.dataset.vsHls;
    if(!flux||v._vsHls||v._vsHlsEnCours)return;
    v._vsHlsEnCours=true;
    chargerBiblioHls().then(Hls=>{
      v._vsHlsEnCours=false;
      if(!Hls||!Hls.isSupported()){
        if(!v.getAttribute('src')&&v.dataset.vsMp4){v.src=v.dataset.vsMp4;v.preload='auto';v.load();}
        return;
      }
      const lecteur=new Hls({
        maxBufferLength:15,
        maxMaxBufferLength:30,
        capLevelToPlayerSize:true,
        startLevel:0,
        abrEwmaDefaultEstimate:600000
      });
      lecteur.on(Hls.Events.ERROR,(_e,d)=>{
        if(!d||!d.fatal)return;
        try{lecteur.destroy();}catch{}
        v._vsHls=null;
        if(v.dataset.vsMp4){v.src=v.dataset.vsMp4;v.preload='auto';v.load();}
      });
      lecteur.loadSource(flux);
      lecteur.attachMedia(v);
      v._vsHls=lecteur;
    });
  };

  const detacherHls=(v)=>{
    if(!v||!v._vsHls)return;
    try{v._vsHls.destroy();}catch{}
    v._vsHls=null;
  };

  let hlsSupporte=null;
  const hlsNatif=()=>{
    if(hlsSupporte===null){
      const sonde=document.createElement('video');
      hlsSupporte=!!(sonde.canPlayType('application/vnd.apple.mpegurl')||sonde.canPlayType('application/x-mpegURL'));
    }
    return hlsSupporte;
  };

  const attachVideoMonitor=v=>{
    if(!v||v._vsMon)return;v._vsMon=true;
    let st=null,last=0,c=0;
    const stop=()=>{if(st){clearInterval(st);st=null;}c=0;};
    const ck=()=>{if(v.paused||v.ended)return stop();if(v.currentTime===last){if(++c>=4){try{v.currentTime=Math.max(0,v.currentTime-0.05);v.play().catch(()=>{});}catch{}c=0;}}else{c=0;last=v.currentTime;}};
    const start=()=>{stop();st=setInterval(ck,200);};
    v.addEventListener('waiting',start);v.addEventListener('stalled',start);
    v.addEventListener('playing',stop);v.addEventListener('pause',stop);
    v.addEventListener('ended',stop);v.addEventListener('error',stop);
  };

  function buildSegs(tl,n){
    tl.innerHTML='';
    for(let i=0;i<n;i++){
      const s=document.createElement('span');s.className='vs-seg';
      const b=document.createElement('span');b.className='vs-seg__bar';
      s.appendChild(b);tl.appendChild(s);
    }
  }
  const getSeg=(tl,i)=>tl.querySelectorAll('.vs-seg__bar')[i];
  const fillTo=(tl,i,pct)=>{const b=getSeg(tl,i);if(b)b.style.width=pct+'%';};
  const fillDone=(tl,upTo)=>{for(let i=0;i<upTo;i++){const b=getSeg(tl,i);if(b)b.style.width='100%';}};
  const resetFrom=(tl,from)=>{const bs=tl.querySelectorAll('.vs-seg__bar');for(let i=from;i<bs.length;i++)bs[i].style.width='0%';};

  function getActiveMed(slide){
    return slide&&(slide.querySelector('.vs-media-item.is-active .vs-video')||slide.querySelector('.vs-media-item.is-active .vs-img'));
  }
  function posOverlay(slide){
    if(!slide)return;
    const med=getActiveMed(slide),ov=slide.querySelector('.vs-overlay');
    if(!med||!ov)return;
    const mr=med.getBoundingClientRect(),sr=slide.getBoundingClientRect();
    if(!mr.width||!mr.height)return;
    ov.style.left=mr.left-sr.left+'px';ov.style.top=mr.top-sr.top+'px';
    ov.style.width=mr.width+'px';ov.style.height=mr.height+'px';
  }
  function setArrowTop(btn,centerY,fixedH){
    btn.style.top=Math.round(centerY-fixedH/2)+'px';
    btn.style.transform='none';
    btn.style.marginTop='0';
  }

  function mountUI(slide,tl,metaEl,actions){
    if(!slide)return;
    const ov=slide.querySelector('.vs-overlay');
    if(!ov)return;
    if(tl&&tl.parentElement!==ov)ov.appendChild(tl);
    if(metaEl&&metaEl.parentElement!==ov)ov.appendChild(metaEl);
    if(actions&&actions.parentElement!==ov)ov.appendChild(actions);
  }

  function initPulse(root,modal){
    const wrap=$('.vs-strip-wrap',root),strip=$('.vs-strip',root),target=$('.vs-bubble.is-pulsing',root);
    if(!wrap||!strip||!target)return null;
    const el=document.createElement('span');el.className='vs-pulse-float';wrap.appendChild(el);
    const bg=getComputedStyle(root).getPropertyValue('--vs-ring-bg').trim();
    if(bg)el.style.background=bg;
    let raf=null;
    const upd=()=>{
      raf=null;
      if(modal?.dataset.open==='true'||!root.contains(target))return void(el.style.display='none');
      const ta=target.getBoundingClientRect(),sa=strip.getBoundingClientRect(),wa=wrap.getBoundingClientRect();
      if(!ta.width||!ta.height)return void(el.style.display='none');
      const pad=parseFloat(getComputedStyle(root).getPropertyValue('--pulse-hide-pad'))||0;
      if(ta.left<sa.left+pad||ta.right>sa.right-pad||ta.top<sa.top+pad||ta.bottom>sa.bottom-pad)return void(el.style.display='none');
      const bleed=parseFloat(getComputedStyle(root).getPropertyValue('--pulse-bleed'))||12;
      el.style.display='block';
      el.style.width=ta.width+2*bleed+'px';el.style.height=ta.height+2*bleed+'px';
      el.style.left=ta.left-wa.left+ta.width/2+'px';el.style.top=ta.top-wa.top+ta.height/2+'px';
    };
    const req=()=>{if(!raf)raf=requestAnimationFrame(upd);};
    strip.addEventListener('scroll',req,{passive:true});
    window.addEventListener('resize',req,{passive:true});
    window.addEventListener('orientationchange',req);
    window.addEventListener('scroll',req,{passive:true});
    req();setTimeout(req,50);
    return{
      show(){req();},
      hide(){el.style.display='none';},
      destroy(){strip.removeEventListener('scroll',req);window.removeEventListener('resize',req);window.removeEventListener('orientationchange',req);window.removeEventListener('scroll',req);el.remove();}
    };
  }

  function createCube(container,wrapper,slideEls,opts){
    const cube={
      el:container,
      wrapper:wrapper,
      slides:slideEls,
      activeIndex:0,
      previousIndex:0,
      animating:false,
      isBeginning:true,
      isEnd:slideEls.length<=1,
      _speed:opts.speed||420,
      _onStart:opts.onTransitionStart||null,
      _onEnd:opts.onTransitionEnd||null,
      _onResize:opts.onResize||null,
      _fb:null
    };

    container.style.overflow='hidden';
    wrapper.style.position='relative';
    wrapper.style.width='100%';
    wrapper.style.height='100%';
    wrapper.style.transformStyle='preserve-3d';

    function applyPerspective(){
      var h=container.clientWidth/2;
      wrapper.style.transform='translateZ(-'+h+'px)';
    }

    function layout(){
      var h=container.clientWidth/2;
      applyPerspective();
      cube.slides.forEach((s,i)=>{
        s.style.position='absolute';
        s.style.inset='0';
        s.style.backfaceVisibility='hidden';
        s.style.transition='none';
        if(i===cube.activeIndex){
          s.style.transform='rotateY(0deg) translateZ('+h+'px)';
          s.style.visibility='visible';
        }else{
          s.style.transform='rotateY(90deg) translateZ('+h+'px)';
          s.style.visibility='hidden';
        }
      });
    }

    cube.slideTo=function(index,speed){
      if(typeof speed==='undefined')speed=cube._speed;
      if(index<0||index>=cube.slides.length)return false;
      if(index===cube.activeIndex){layout();return false;}
      if(cube.animating)return false;

      var h=container.clientWidth/2;
      const dir=index>cube.activeIndex?1:-1;
      const outgoing=cube.slides[cube.activeIndex];
      const incoming=cube.slides[index];
      cube.previousIndex=cube.activeIndex;

      if(speed===0){
        outgoing.style.transition='none';
        incoming.style.transition='none';
        outgoing.style.visibility='hidden';
        outgoing.style.transform='rotateY('+(-dir*90)+'deg) translateZ('+h+'px)';
        incoming.style.visibility='visible';
        incoming.style.transform='rotateY(0deg) translateZ('+h+'px)';
        cube.activeIndex=index;
        cube.isBeginning=index===0;
        cube.isEnd=index===cube.slides.length-1;
        return true;
      }

      cube.animating=true;
      if(cube._onStart)cube._onStart();

      incoming.style.transition='none';
      incoming.style.transform='rotateY('+(dir*90)+'deg) translateZ('+h+'px)';
      incoming.style.visibility='visible';
      incoming.offsetHeight;

      const ease=speed+'ms ease';
      outgoing.style.transition='transform '+ease;
      incoming.style.transition='transform '+ease;

      outgoing.style.transform='rotateY('+(-dir*90)+'deg) translateZ('+h+'px)';
      incoming.style.transform='rotateY(0deg) translateZ('+h+'px)';

      function done(){
        incoming.removeEventListener('transitionend',done);
        clearTimeout(cube._fb);
        outgoing.style.visibility='hidden';
        outgoing.style.transition='none';
        incoming.style.transition='none';
        cube.activeIndex=index;
        cube.isBeginning=index===0;
        cube.isEnd=index===cube.slides.length-1;
        cube.animating=false;
        if(cube._onEnd)cube._onEnd(cube.previousIndex);
      }

      incoming.addEventListener('transitionend',done,{once:true});
      cube._fb=setTimeout(done,speed+50);
      return true;
    };

    cube.slideNext=function(){
      if(cube.isEnd||cube.animating)return false;
      return cube.slideTo(cube.activeIndex+1);
    };

    cube.slidePrev=function(){
      if(cube.isBeginning||cube.animating)return false;
      return cube.slideTo(cube.activeIndex-1);
    };

    cube.update=function(){layout();};

    const ro=new ResizeObserver(()=>{
      layout();
      if(cube._onResize)cube._onResize();
    });
    ro.observe(container);

    layout();
    return cube;
  }

  function initRoot(root){
    if(!root)return;
    const modal=document.getElementById(root.id+'-modal');
    const strip=$('.vs-strip',root);
    const stageEl=$('.vs-stage',modal);
    const cubeWrap=stageEl?$('.vs-cube-wrap',stageEl):null;
    if(!strip||!stageEl||!cubeWrap)return;

    let drag=false,startX=0,scroll0=0,didDrag=false;
    strip.addEventListener('mousedown',e=>{drag=true;didDrag=false;startX=e.pageX;scroll0=strip.scrollLeft;strip.classList.add('is-drag');e.preventDefault();});
    addEventListener('mousemove',e=>{if(!drag)return;const dx=e.pageX-startX;if(Math.abs(dx)>2)didDrag=true;strip.scrollLeft=scroll0-dx;});
    addEventListener('mouseup',()=>{drag=false;strip.classList.remove('is-drag');});
    strip.addEventListener('click',e=>{if(didDrag)e.preventDefault();});
    strip.addEventListener('touchstart',e=>{startX=e.touches[0].pageX;scroll0=strip.scrollLeft;},{passive:true});
    strip.addEventListener('touchmove',e=>{strip.scrollLeft=scroll0-(e.touches[0].pageX-startX);},{passive:true});

    const updFade=()=>{
      const max=Math.max(0,strip.scrollWidth-strip.clientWidth);
      strip.dataset.atStart=strip.scrollLeft<=1?'true':'false';
      strip.dataset.atEnd=strip.scrollLeft>=max-1?'true':'false';
      if(max<=0){strip.dataset.atStart='true';strip.dataset.atEnd='true';}
    };
    strip.addEventListener('scroll',updFade,{passive:true});
    addEventListener('resize',updFade);
    requestAnimationFrame(updFade);setTimeout(updFade,100);

    const mobile=window.matchMedia('(hover: none) and (pointer: coarse)').matches||'ontouchstart'in window;
    const tl=$('.vs-timeline',modal);
    const metaEl=$('.vs-meta',modal);
    const avatar=$('.vs-avatar',modal);
    const metaTitle=$('.vs-meta__title',modal);
    const actions=$('.vs-actions',modal);
    const closeBtn=$('.vs-btn--close',modal);
    const ppBtn=$('.vs-btn--play',modal);
    const muteBtn=$('.vs-btn--mute',modal);
    const mainPrev=$('.vs-main-prev',modal);
    const mainNext=$('.vs-main-next',modal);
    const mediaPrev=$('.vs-media-prev',modal);
    const mediaNext=$('.vs-media-next',modal);

    const items=$$('.vs-item',root);
    if(!items.length)return;

    const pulse=initPulse(root,modal);

    const prevSecs=parseFloat(root.dataset.previewSeconds||'0');
    const prevVid=$('.vs-bubble.is-preview .vs-cover-video',root);
    if(prevVid&&prevVid.dataset.src){
      const startPreview=()=>{
        if(prevVid.src)return;
        prevVid.muted=true;prevVid.setAttribute('playsinline','');prevVid.preload='auto';prevVid.src=prevVid.dataset.src;
        if(!prevSecs)prevVid.loop=true;
        const tp=()=>prevVid.play().catch(()=>{});
        prevVid.addEventListener('loadedmetadata',tp);prevVid.addEventListener('canplay',tp,{once:true});
        if(prevSecs)prevVid.addEventListener('timeupdate',()=>{const cap=Math.min(prevSecs,prevVid.duration||Infinity);if(prevVid.currentTime>=cap-.05)prevVid.currentTime=0;});
        modal.addEventListener('transitionstart',()=>{try{prevVid.pause();}catch{}},{once:true});
      };
      if(typeof IntersectionObserver!=='undefined'){
        const io=new IntersectionObserver((entries)=>{
          entries.forEach((e)=>{if(e.isIntersecting){startPreview();io.disconnect();}});
        },{rootMargin:'200px'});
        io.observe(prevVid);
      }else{
        startPreview();
      }
      const resumePreview=()=>{
        if(!prevVid.src)return;
        if(modal.dataset.open==='true')return;
        if(document.hidden)return;
        if(prevVid.paused){
          prevVid.muted=true;
          prevVid.play().catch(()=>{});
        }
      };
      document.body.addEventListener('modalClosed',()=>{setTimeout(resumePreview,0);});
    }

    let cube=null,built=false;
    let curMediaIdx=0;
    let imgTimer=null,vidRaf=null;
    let tapHandlerAdded=false;
    let globalMuted=true;
    let enterAtLast=false;
    let isSlideTransitioning=false;

    const clearTimers=()=>{if(imgTimer){clearTimeout(imgTimer);imgTimer=null;}if(vidRaf){cancelAnimationFrame(vidRaf);vidRaf=null;}};
    const getML=slide=>{try{return JSON.parse(slide.dataset.mediaList||'[]');}catch{return[];}};
    const updPP=v=>{modal.dataset.vsPlaying=v&&!v.paused?'true':'false';};
    const setVideoCtrl=isVid=>{if(ppBtn)ppBtn.style.display=isVid?'':'none';if(muteBtn)muteBtn.style.display=isVid?'':'none';};
    const shouldIgnoreTouchTarget=target=>target?.closest('.vs-actions,.vs-meta,.vs-timeline');

    function goPrevSlide(){
      if(!cube||cube.isBeginning||cube.animating||isSlideTransitioning)return false;
      isSlideTransitioning=true;
      enterAtLast=true;
      cube.slidePrev();
      return true;
    }

    function goNextSlide(){
      if(!cube||cube.isEnd||cube.animating||isSlideTransitioning)return false;
      isSlideTransitioning=true;
      cube.slideNext();
      return true;
    }

    function posAll(slide){
      if(!slide)return;
      mountUI(slide,tl,metaEl,actions);
      posOverlay(slide);
      const ml=getML(slide);
      const med=getActiveMed(slide);
      const mr=med?med.getBoundingClientRect():null;
      const centerY=mr&&mr.height?Math.round(mr.top+mr.height/2):Math.round(window.innerHeight/2);
      if(!mobile&&mainPrev&&mainNext&&mr){
        mainPrev.style.left=Math.max(12,mr.left-(48+16))+'px';
        mainNext.style.left=Math.min(window.innerWidth-(48+12),mr.right+16)+'px';
        setArrowTop(mainPrev,centerY,48);setArrowTop(mainNext,centerY,48);
      }
      if(!mobile&&ml.length>1&&mediaPrev&&mediaNext){
        mediaPrev.style.visibility='';mediaNext.style.visibility='';
        if(mr){mediaPrev.style.left=mr.left+8+'px';mediaNext.style.left=mr.right-40+'px';}
        setArrowTop(mediaPrev,centerY,32);setArrowTop(mediaNext,centerY,32);
        mediaPrev.disabled=curMediaIdx===0;
        mediaNext.disabled=curMediaIdx===ml.length-1;
      }else{
        if(mediaPrev)mediaPrev.style.visibility='hidden';
        if(mediaNext)mediaNext.style.visibility='hidden';
      }
      if(mainPrev)mainPrev.disabled=!cube||cube.isBeginning;
      if(mainNext)mainNext.disabled=!cube||cube.isEnd;
    }
    function posAllRetry(slide){
      posAll(slide);
      setTimeout(()=>posAll(slide),80);
      setTimeout(()=>posAll(slide),250);
    }

    function chargerVideo(vid){
      if(!vid)return;
      if(vid.dataset.vsHls){brancherHls(vid);return;}
      try{if(vid.preload!=='auto'){vid.preload='auto';vid.load();}}catch{}
    }

    function margeSuffisante(v){
      try{
        if(v.readyState>=4)return true;
        const b=v.buffered;
        if(!b||!b.length)return false;
        const avance=b.end(b.length-1)-v.currentTime;
        const reste=(v.duration&&!isNaN(v.duration))?v.duration-v.currentTime:8;
        return avance>=Math.min(8,Math.max(1,reste-0.5));
      }catch{return false;}
    }

    function chargerQuandStable(courante,cible){
      if(!cible)return;
      if(!courante||courante===cible){chargerVideo(cible);return;}
      if(cible._vsAttente){
        cible._vsAttente.source.removeEventListener('progress',cible._vsAttente.fn);
        cible._vsAttente.source.removeEventListener('canplaythrough',cible._vsAttente.fn);
        clearTimeout(cible._vsAttente.minuteur);
        cible._vsAttente=null;
      }
      if(margeSuffisante(courante)){chargerVideo(cible);return;}
      const lancer=()=>{
        courante.removeEventListener('progress',verifier);
        courante.removeEventListener('canplaythrough',verifier);
        if(cible._vsAttente)clearTimeout(cible._vsAttente.minuteur);
        cible._vsAttente=null;
        chargerVideo(cible);
      };
      const verifier=()=>{if(margeSuffisante(courante))lancer();};
      cible._vsAttente={source:courante,fn:verifier,minuteur:setTimeout(lancer,3000)};
      courante.addEventListener('progress',verifier);
      courante.addEventListener('canplaythrough',verifier);
    }

    function prechaufferSuivante(slide,idx){
      if(!slide)return;
      const items=slide.querySelectorAll('.vs-media-item');
      const courante=items[idx]?items[idx].querySelector('video'):null;
      const suivant=items[idx+1];
      let cible=suivant?suivant.querySelector('video'):null;
      if(!cible){
        const slideSuivante=slide.nextElementSibling;
        cible=slideSuivante?slideSuivante.querySelector('video'):null;
      }
      chargerQuandStable(courante,cible);
    }

    function playAt(slide,idx,fromStart){
      if(!slide)return;
      const ml=getML(slide);
      if(!ml.length||!ml[idx])return;
      clearTimers();
      slide.querySelectorAll('.vs-media-item').forEach((mi,i)=>{
        if(i!==idx){const v=mi.querySelector('video');if(v){safePause(v);v.onended=null;}}
      });
      curMediaIdx=idx;
      fillDone(tl,idx);
      resetFrom(tl,idx);
      slide.querySelectorAll('.vs-media-item').forEach((el,i)=>el.classList.toggle('is-active',i===idx));
      requestAnimationFrame(()=>posAllRetry(slide));
      const m=ml[idx];
      const activeItem=slide.querySelector('.vs-media-item.is-active');
      prechaufferSuivante(slide,idx);
      if(m.type==='video'){
        setVideoCtrl(true);
        const vid=activeItem?.querySelector('.vs-video');
        if(vid){
          if(activeItem)activeItem.classList.remove('is-ready');
          const revele=()=>{if(activeItem)activeItem.classList.add('is-ready');};
          if(typeof vid.requestVideoFrameCallback==='function')vid.requestVideoFrameCallback(revele);
          else vid.addEventListener('playing',revele,{once:true});
          chargerVideo(vid);
          if(vid.dataset.vsHls&&!vid._vsHls&&!vid._vsHlsEnCours)brancherHls(vid);
          attachVideoMonitor(vid);
          modal.dataset.vsMuted=globalMuted?'true':'false';
          safePlay(vid,{muted:globalMuted,fromStart:!!fromStart}).then(()=>updPP(vid));
          const tick=()=>{if(vid.duration&&!isNaN(vid.duration))fillTo(tl,idx,Math.min(100,(vid.currentTime/vid.duration)*100));vidRaf=requestAnimationFrame(tick);};
          vidRaf=requestAnimationFrame(tick);
          vid.onended=()=>{if(modal.dataset.open!=='true')return;fillTo(tl,idx,100);advance(slide,idx,ml);};
        }
      }else{
        setVideoCtrl(false);
        const dur=m.duration||5000;let elapsed=0;
        const tick=()=>{elapsed+=50;fillTo(tl,idx,Math.min(100,(elapsed/dur)*100));if(elapsed>=dur){fillTo(tl,idx,100);advance(slide,idx,ml);}else{imgTimer=setTimeout(tick,50);}};
        imgTimer=setTimeout(tick,50);
      }
      if(metaTitle)metaTitle.textContent=slide.dataset.title||'';
      if(avatar){const p=slide.dataset.poster;if(p){avatar.src=p;avatar.style.display='';}else{avatar.removeAttribute('src');avatar.style.display='none';}}
    }

    function advance(slide,idx,ml){
      if(modal.dataset.open!=='true')return;
      if(idx<ml.length-1)playAt(slide,idx+1,true);
      else if(goNextSlide())return;
      else closeModal();
    }

    function stopSlide(slide){
      clearTimers();
      if(!slide)return;
      slide.querySelectorAll('video').forEach(v=>{safePause(v);v.onended=null;});
    }

    function releaseModalVideos(){
      modal.querySelectorAll('video').forEach(v=>{
        try{
          safePause(v);
          if(v._vsHls){detacherHls(v);v.removeAttribute('src');v.load();return;}
          if(!v.dataset.vsSrc&&v.src)v.dataset.vsSrc=v.src;
          if(!v.dataset.vsSrc)return;
          v.removeAttribute('src');
          v.load();
        }catch{}
      });
    }

    function restoreModalVideos(){
      modal.querySelectorAll('video').forEach(v=>{
        try{
          if(!v.getAttribute('src')&&v.dataset.vsSrc){
            v.preload='none';
            v.src=v.dataset.vsSrc;
          }
        }catch{}
      });
    }

    function enterSlide(slide){
      if(!slide)return;
      const ml=getML(slide);
      buildSegs(tl,ml.length);
      const startIdx=enterAtLast?Math.max(0,ml.length-1):0;
      enterAtLast=false;
      playAt(slide,startIdx,true);
      const suivante=slide.nextElementSibling;
      if(suivante){
        const medias=slide.querySelectorAll('.vs-media-item');
        const courante=medias[startIdx]?medias[startIdx].querySelector('video'):null;
        chargerQuandStable(courante,suivante.querySelector('video'));
      }
    }

    let isClosing=false;
    function avalerProchainClic(){
      const avaler=(e)=>{e.stopPropagation();e.preventDefault();};
      document.addEventListener('click',avaler,true);
      setTimeout(()=>document.removeEventListener('click',avaler,true),400);
    }

    function closeModal(animate){
      if(isClosing)return;
      avalerProchainClic();
      if(animate&&mobile){
        isClosing=true;
        const slide=cube?.slides?.[cube.activeIndex];
        modal.style.transition='opacity .3s ease';
        modal.style.opacity='0';
        if(slide){slide.style.transition='transform .3s ease';slide.style.transform='translateY(100vh)';}
        const finish=()=>{
          modal.style.transition='';modal.style.opacity='';
          if(slide){slide.style.transition='';slide.style.transform='';}
          modal.dataset.open='false';modal.setAttribute('aria-hidden','true');
          stopSlide(slide);
          releaseModalVideos();
          cube?.update();
          unlockScroll();pulse?.show();
          if(prevVid){try{prevVid.currentTime=0;}catch{}requestAnimationFrame(()=>tryPlay(prevVid));}
          isClosing=false;
        };
        setTimeout(finish,320);
      }else{
        modal.dataset.open='false';modal.setAttribute('aria-hidden','true');
        stopSlide(cube?.slides?.[cube.activeIndex]);
        releaseModalVideos();
        unlockScroll();pulse?.show();
        if(prevVid){try{prevVid.currentTime=0;}catch{}requestAnimationFrame(()=>tryPlay(prevVid));}
      }
    }

    function buildSlide(item,idx){
      let ml;try{ml=JSON.parse(item.dataset.mediaList||'[]');}catch{ml=[];}
      if(!ml.length)return null;
      const slide=document.createElement('div');
      slide.className='vs-slide';
      slide.dataset.index=idx;
      slide.dataset.title=item.dataset.title||'';
      slide.dataset.poster=item.getAttribute('data-cover-square')||'';
      slide.dataset.mediaList=item.dataset.mediaList||'[]';
      slide.style.position='relative';
      ml.forEach((m,mi)=>{
        const wrap=document.createElement('div');
        wrap.className='vs-media-item'+(mi===0?' is-active':'');
        if(m.type==='video'){
          const vid=document.createElement('video');
          vid.className='vs-video';
          vid.setAttribute('playsinline','');vid.setAttribute('webkit-playsinline','');
          vid.setAttribute('preload','none');vid.setAttribute('disablepictureinpicture','');
          vid.setAttribute('controlslist','nodownload noplaybackrate nofullscreen');
          vid.muted=true;vid.setAttribute('muted','');vid.style.pointerEvents='none';
          if(m.hls&&hlsNatif()){
            vid.src=m.hls;
          }else if(m.hls){
            vid.dataset.vsHls=m.hls;
            vid.dataset.vsMp4=m.url;
          }else{
            vid.src=m.url;
          }
          vid.addEventListener('play',()=>updPP(vid));vid.addEventListener('pause',()=>updPP(vid));
          attachVideoMonitor(vid);
          const imageTransition=m.frame||m.cover;
          if(imageTransition){
            const affiche=document.createElement('img');
            affiche.className='vs-media-poster';
            affiche.src=imageTransition;
            affiche.alt='';
            affiche.decoding='async';
            wrap.appendChild(affiche);
          }
          wrap.appendChild(vid);
        }else{
          const img=document.createElement('img');
          img.className='vs-img';img.src=m.url;img.alt='';img.draggable=false;
          wrap.appendChild(img);
        }
        slide.appendChild(wrap);
      });

      const ov=document.createElement('div');
      ov.className=mobile?'vs-overlay':'vs-overlay vs-no-swipe';
      ov.style.cssText='position:absolute;inset:0;z-index:7;pointer-events:auto;background:transparent;';
      slide.appendChild(ov);

      const rp=()=>posOverlay(slide);
      slide.querySelectorAll('video,img').forEach(el=>{el.addEventListener('loadedmetadata',rp);el.addEventListener('load',rp);});
      requestAnimationFrame(rp);setTimeout(rp,50);
      return slide;
    }

    function construire(){
      if(built)return;
      items.forEach((it,i)=>{const s=buildSlide(it,i);if(s)cubeWrap.appendChild(s);});
      built=true;
    }

    function prechauffer(idx){
      construire();
      if(!hlsNatif())chargerBiblioHls();
      const bloc=cubeWrap.querySelector('.vs-slide[data-index="'+idx+'"]');
      const affiche=bloc&&bloc.querySelector('.vs-media-poster');
      if(affiche&&affiche.src){const img=new Image();img.src=affiche.src;}
      const slide=cubeWrap.querySelector('.vs-slide[data-index="'+idx+'"]');
      const vid=slide&&slide.querySelector('video');
      if(!vid)return;
      try{if(vid.preload!=='auto'){vid.preload='auto';vid.load();}}catch{}
    }

    items.forEach((item,idx)=>{
      ['pointerenter','touchstart'].forEach(ev=>{
        item.addEventListener(ev,()=>prechauffer(idx),{passive:true});
      });
      item.addEventListener('click',()=>{
        const cs=getComputedStyle(root);
        for(let i=0;i<cs.length;i++){const p=cs[i];if(p.startsWith('--vs-'))modal.style.setProperty(p,cs.getPropertyValue(p));}
        if(modal.parentElement!==document.body)document.body.appendChild(modal);
        construire();
        restoreModalVideos();
        modal.dataset.open='true';modal.setAttribute('aria-hidden','false');
        lockScroll();pulse?.hide();
        if(prevVid)prevVid.pause();
        if(!cube){
          const allSlides=Array.from(cubeWrap.querySelectorAll('.vs-slide'));
          cube=createCube(stageEl,cubeWrap,allSlides,{
            speed:420,
            onTransitionStart(){
              isSlideTransitioning=true;
              clearTimers();
              if(mediaPrev)mediaPrev.style.visibility='hidden';
              if(mediaNext)mediaNext.style.visibility='hidden';
            },
            onTransitionEnd(prevIdx){
              isSlideTransitioning=false;
              stopSlide(cube.slides?.[prevIdx]);
              enterSlide(cube.slides?.[cube.activeIndex]);
              posAllRetry(cube.slides?.[cube.activeIndex]);
            },
            onResize(){
              posAllRetry(cube.slides?.[cube.activeIndex]);
            }
          });

          if(!mobile){
            if(mainPrev)mainPrev.style.display='';
            if(mainNext)mainNext.style.display='';
            mainPrev?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();goPrevSlide();});
            mainNext?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();goNextSlide();});
          }else{
            if(mainPrev)mainPrev.style.display='none';
            if(mainNext)mainNext.style.display='none';
          }

          if(!mobile){
            let dragX0=0,dragging=false;
            stageEl.addEventListener('mousedown',e=>{
              if(cube.animating||e.target.closest('.vs-actions,.vs-meta,.vs-timeline,.vs-btn--play,.vs-btn--mute,.vs-btn--close,.vs-media-prev,.vs-media-next,.vs-main-prev,.vs-main-next'))return;
              dragging=true;dragX0=e.clientX;e.preventDefault();
            });
            window.addEventListener('mousemove',e=>{if(dragging)e.preventDefault();});
            window.addEventListener('mouseup',e=>{
              if(!dragging)return;
              dragging=false;
              const dx=e.clientX-dragX0;
              if(dx>50)goPrevSlide();
              else if(dx<-50)goNextSlide();
            });
          }

          if(mobile&&!tapHandlerAdded){
            tapHandlerAdded=true;
            let txS=0,tyS=0;
            stageEl.addEventListener('touchstart',e=>{txS=e.touches[0].clientX;tyS=e.touches[0].clientY;},{passive:true});
            stageEl.addEventListener('touchend',e=>{
              const t=e.changedTouches[0];
              const diffX=t.clientX-txS;
              const diffY=t.clientY-tyS;
              const dx=Math.abs(diffX);
              const dy=Math.abs(diffY);
              if(isSlideTransitioning||isClosing)return;
              if(shouldIgnoreTouchTarget(e.target))return;
              if(diffY>60&&dy>dx*1.5){
                if(e.cancelable)e.preventDefault();
                closeModal(true);
                return;
              }
              if(dx>45&&dx>dy*1.2){
                if(e.cancelable)e.preventDefault();
                if(diffX>0)goPrevSlide();
                else goNextSlide();
                return;
              }
              if(dx<20&&dy<40){
                const sl=cube?.slides?.[cube.activeIndex];if(!sl)return;
                if(e.cancelable)e.preventDefault();
                if(t.clientX<window.innerWidth/2){
                  if(curMediaIdx>0)playAt(sl,curMediaIdx-1,true);
                  else goPrevSlide();
                }else{
                  advance(sl,curMediaIdx,getML(sl));
                }
              }
            });
          }

          const mq=window.matchMedia('(hover: none) and (pointer: coarse)');
          mq.addEventListener?.('change',e=>{
            if(e.matches){if(mainPrev)mainPrev.style.display='none';if(mainNext)mainNext.style.display='none';}
            else{if(mainPrev)mainPrev.style.display='';if(mainNext)mainNext.style.display='';posAll(cube.slides?.[cube.activeIndex]);}
          });
        }
        cube.slideTo(idx,0);
        stopSlide(cube.slides?.[cube.activeIndex]);
        enterSlide(cube.slides?.[cube.activeIndex]);
        posAllRetry(cube.slides?.[cube.activeIndex]);
      });
    });

    closeBtn?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();closeModal();});

    ppBtn?.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const vid=cube?.slides?.[cube.activeIndex]?.querySelector('.vs-media-item.is-active video');
      if(!vid)return;
      vid.paused?safePlay(vid,{muted:globalMuted}):safePause(vid);
    });

    muteBtn?.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const vid=cube?.slides?.[cube.activeIndex]?.querySelector('.vs-media-item.is-active video');
      if(!vid)return;
      vid.muted=!vid.muted;globalMuted=vid.muted;modal.dataset.vsMuted=vid.muted?'true':'false';
      if(vid.paused)safePlay(vid,{muted:vid.muted});
    });

    mediaPrev?.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const slide=cube?.slides?.[cube.activeIndex];
      if(!slide||curMediaIdx<=0)return;
      playAt(slide,curMediaIdx-1,true);
    });

    mediaNext?.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const slide=cube?.slides?.[cube.activeIndex];
      if(!slide)return;
      const ml=getML(slide);
      if(curMediaIdx>=ml.length-1)return;
      playAt(slide,curMediaIdx+1,true);
    });

    modal.addEventListener('click',e=>{
      if(mobile)return;
      if(e.target.closest('.vs-overlay,.vs-actions,.vs-meta,.vs-timeline,.vs-main-prev,.vs-main-next,.vs-media-prev,.vs-media-next'))return;
      const slide=cube?.slides?.[cube.activeIndex];
      const med=getActiveMed(slide);
      if(med){const r=med.getBoundingClientRect();if(e.clientX>=r.left&&e.clientX<=r.right&&e.clientY>=r.top&&e.clientY<=r.bottom)return;}
      closeModal();
    });
  }

  function initAll(){$$('.vs-root').forEach(initRoot);}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',initAll):initAll();
  document.addEventListener('shopify:section:load',initAll);
}();
